import React, { useContext } from "react";
import { DIMENSIONS } from "../../../utils/Dimensions";
import { Button, CircularProgress } from "@material-ui/core";
import { observer } from "mobx-react";
import styled from "styled-components";
import Box from "@material-ui/core/Box";
import { ContainerStoreContext } from "../ContainerStore";

function ActionButtons(props) {
  const containerStore = useContext(ContainerStoreContext);
  const [isDeleteExecuting, setDeleteExecutionStatus] = React.useState(false);
  let isSubSheetView =
    props.store?.view?.type == "table" &&
    props.store?.view?.list_id &&
    props.store?.view?.options?.main_list_id &&
    props.store?.view?.list_id != props.store?.view?.options?.main_list_id;

  const handleEditDuplicate = (action) => {
    let selectedNodes = props.gridApi.getSelectedNodes();
    if (action == "Edit") {
      containerStore?.showForm("Edit", selectedNodes[0]?.data?.row_id);
    } else if (action == "Duplicate") {
      containerStore?.showForm("New", "", selectedNodes[0]?.data?.row_id);
    }
    props.store.resetSelectedRecordsCount();
    selectedNodes[0].setSelected(false);
    let parentDOM = document.getElementById(props.store.gridId);
    let array = Array.from(parentDOM.getElementsByClassName("rowIdSelection"));
    parentDOM.querySelectorAll("input[id='defaultChecked']")[0].checked = false;
    array.map((row) => {
      if (row.checked) {
        row.checked = false;
      }
    });
  };

  const getRestoreButton = () => {
    let row_ids = "" , count = 0;
    let selectedNodes = props.gridApi.getSelectedNodes();
    let operationColumn = 0;
    props.store.columns.forEach((element) => {
      if (element.name == "Operation") {
        operationColumn = element.id;
      }
    });

    selectedNodes.map((node) => {
      let operation = node.data["column_" + operationColumn];
      if (["delete-row", "delete-handler", "delete-event"].includes(operation)) {
        row_ids = row_ids + (row_ids.length > 0 ? "," : "") + node.id;
        count += 1;
      }
    });

    if(count == 0){
      return null
    }
    return (
      <StyledButton
        variant="text"
        onClick={() => {
          props.store.resetSelectedRecordsCount();
          if (row_ids.length > 0) {
            props.store.handleRestore(row_ids);
          }
          props.gridApi.deselectAll();
          let parentDOM = document.getElementById(props.store.gridId);
          let array = Array.from(parentDOM.getElementsByClassName("rowIdSelection"));
          parentDOM.querySelectorAll("input[id='defaultChecked']")[0].checked = false;
          array.map((row) => {
            if (row.checked) {
              row.checked = false;
            }
          });
        }}
      >
        {"Restore(" + count + ")"}
      </StyledButton>
    );
  };

    const renderEditDuplicateButtons = () => {
    const selectedNodes = props.gridApi.getSelectedNodes();
    if (
      props.noOfRecordsSelected == 1 &&
      selectedNodes.length > 0 &&
      selectedNodes[0]?.data?.row_id !== ""
    ) {
      return (
        <div>
          {containerStore.permissions?.canEdit()[0] && (
            <StyledButton
              variant="text"
              onClick={() => {
                handleEditDuplicate("Edit");
              }}
            >
              edit
            </StyledButton>
          )}
          {containerStore.permissions?.canAdd() && (
            <StyledButton
              variant="text"
              onClick={() => {
                handleEditDuplicate("Duplicate");
              }}
            >
              duplicate
            </StyledButton>
          )}
        </div>
      );
    } else if (props.noOfRecordsSelected > 1) {
      return (
        <div>
          {/* <StyledBulkEditButton variant="text">
            {"bulk edit(" + props.noOfRecordsSelected + ")"}
          </StyledBulkEditButton> */}
        </div>
      );
    }
  };
  

  return (
    <StyledOuterDiv className="d-flex">
      <StyledInsideDiv className="textCenter d-flex">
        <StyledInnerDiv>
          {renderEditDuplicateButtons()}
          {containerStore.permissions?.canDelete() && (
            <StyledDeleteButton
              variant="text"
              style={{ height: 30, marginRight: "10px", color: "#f87171" }}
              disabled={isDeleteExecuting}
              onClick={async () => {
                try {
                  if (
                    props.store?.props?.view?.type == "table" &&
                    props.store?.props?.view?.list_id &&
                    props.store?.props?.view?.options?.main_list_id &&
                    props.store?.props?.view?.list_id !=
                      props.store?.props?.view?.options?.main_list_id
                  ) {
                    await window.appStore.notificationStore.confirm({
                      description: (
                        <>
                          You cannot delete as this report may have sub-sheet or other sheet
                          columns.<br></br>
                          <b>You can do this action from main view.</b>
                        </>
                      ),
                      confirmationButtonProps: { disabled: true },
                    });
                    return;
                  }          
                  await window.appStore.notificationStore.confirm({
                    description: <>This will delete the selected rows</>,
                  });
                  setDeleteExecutionStatus(true);
                  await props.store.bulkDeleteAction();
                  setDeleteExecutionStatus(false);
                  let parentDOM = document.getElementById(props.store.gridId);
                  parentDOM.querySelectorAll(
                    "input[id='defaultChecked']"
                  )[0].checked = false;
                  props.store.resetSelectedRecordsCount();
                } catch (e) {
                  console.log(e);
                }
                finally {
                  let parentDOM = document.getElementById(props.store.gridId);
                  props.gridApi.deselectAll();
                  parentDOM.querySelectorAll(
                    "input[id='defaultChecked']"
                  )[0].checked = false;
                  let array = Array.from(parentDOM.getElementsByClassName("rowIdSelection"));
                  array.map((row) => {
                    if (row.checked) {
                      row.checked = false;
                    }
                  });
                  props.store.resetSelectedRecordsCount();
                  setDeleteExecutionStatus(false);
                }
              }}
            >
              <Box m={1}>delete</Box>
              {isDeleteExecuting && (
                <CircularProgress size={18} color="inherit" />
              )}
            </StyledDeleteButton>
          )}
          <StyledButton
            variant="text"
            onClick={() => {
              props.store.resetSelectedRecordsCount();
              // let selectedNodes = props.gridApi.getSelectedNodes();
              // selectedNodes.map((node) => {
              //   let rowNode = props.gridApi.getRowNode(node.id);
              //   rowNode.setSelected(false);
              // });
              props.gridApi.deselectAll();
              let parentDOM = document.getElementById(props.store.gridId);
              let array = Array.from(
                parentDOM.getElementsByClassName("rowIdSelection")
              );
              parentDOM.querySelectorAll(
                "input[id='defaultChecked']"
              )[0].checked = false;
              array.map((row) => {
                if (row.checked) {
                  row.checked = false;
                }
              });
            }}
          >
            {"unselect(" + props.noOfRecordsSelected + ")"}
          </StyledButton>
          {props.store?.listConfig?.list?.is_log_sheet == 1 && getRestoreButton()}
          {!isSubSheetView && props.store.activeToolbarActionButtons.map((event, index) => {
            if(!event.position.split(",").includes("bulk-action-menu")){
              return 
            }
            let isLoading, isButtonDisabled;
            isLoading = isButtonDisabled = props.store.executingToolbarEvents[
              event.id
            ]
              ? true
              : false;
            return (
              <StyledButton
                varinat="text"
                disabled={isButtonDisabled}
                onClick={async () => {
                  try {
                    await window.appStore.notificationStore.confirm({
                      title: <>Confirmation</>,
                      description: (
                        <>
                          Are you sure you want to perform this action{" "}
                          {event.name}
                        </>
                      ),
                    });
                    props.store.setExecutingToolbarEventsStatus(event.id, true);
                    await props.store.executeBulkActions(props, event);
                    props.store.setExecutingToolbarEventsStatus(
                      event.id,
                      false
                    );
                  } catch (e) {
                    console.log(e);
                  }
                }}
              >
                <Box m={1}>{event.name}</Box>
                {isLoading && <CircularProgress size={18} color="inherit" />}
              </StyledButton>
            );
          })}
        </StyledInnerDiv>
      </StyledInsideDiv>
    </StyledOuterDiv>
  );
}

const StyledBulkEditButton = styled(Button)`
  height: 30px;
  margin-right: 10px;
  text-transform: uppercase !important;
  padding-right: 19px;
  padding-left: 19px;
`;

const StyledOuterDiv = styled.div`
  height: ${DIMENSIONS.toolbar};
  width: "100%";
`;

const StyledInsideDiv = styled.div`
  flex: 1;
  marginleft: 20;
  alignitems: center;
`;

const StyledInnerDiv = styled.div`
  display: flex;
`;

const StyledButton = styled(Button)`
  height: 30px;
  margin-right: 10px;
  text-transform: uppercase !important;
`;

const StyledDeleteButton = styled(Button)`
  height: 30px;
  margin-right: 10px;
  color: #f87171;
  text-transform: uppercase !important;
`;

export default observer(ActionButtons);